import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { withTheme } from '@shared/lib';
import { ModalCyber } from '@shared/ui/molecules';
import { FetchHintsResponseType } from '@entities/hint';
interface RegionsWithLimitsInstructionsModalProps {
  isOpen: boolean;
  handleClose: () => void;
  content: FetchHintsResponseType['steam']['restrictedAccounts'];
}
const RegionsWithLimitsInstructionsModal: FC<RegionsWithLimitsInstructionsModalProps> = ({
  isOpen,
  handleClose,
  content
}) => <ModalCyber title={content.title} content={<StepsList>
        <StepsList>
          {content.steps.map((item, index) => <StepItem key={item}>
              <StepNumber>{index + 1}</StepNumber>
              <StepText>{item}</StepText>
            </StepItem>)}
        </StepsList>
      </StepsList>} handleClose={handleClose} open={isOpen} />;
export default RegionsWithLimitsInstructionsModal;
const StepsList = /*#__PURE__*/styled('div')({
  name: "StepsList",
  class: "s15f12nc",
  propsAsIs: false
});
const StepItem = /*#__PURE__*/styled('div')({
  name: "StepItem",
  class: "s1kawjv8",
  propsAsIs: false
});
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.state.active;
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.white;
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSCompact;
const _exp4 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.bold;
const _exp5 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xxs;
const StepNumber = withTheme(/*#__PURE__*/styled('div')({
  name: "StepNumber",
  class: "s18k2d6l",
  propsAsIs: false,
  vars: {
    "s18k2d6l-0": [_exp()],
    "s18k2d6l-1": [_exp2()],
    "s18k2d6l-2": [_exp3()],
    "s18k2d6l-3": [_exp4()],
    "s18k2d6l-4": [_exp5(), "px"]
  }
}));
const _exp6 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const _exp7 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSCompact;
const StepText = withTheme(/*#__PURE__*/styled('div')({
  name: "StepText",
  class: "s1r4f0ns",
  propsAsIs: false,
  vars: {
    "s1r4f0ns-0": [_exp6()],
    "s1r4f0ns-1": [_exp7()]
  }
}));

require("./RegionsWithLimitsInstructionsModal.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./RegionsWithLimitsInstructionsModal.tsx");